import { GlobalConfiguration } from '../constants/types';

let globalConfig: GlobalConfiguration = {
  keycloakClientName: import.meta.env.REACT_APP_CLIENT_ID,
  defaultTenant: import.meta.env.REACT_APP_REALM,
  keycloakApiEndpoint: import.meta.env.REACT_APP_KEYCLOAK_API,
  entitystoreApiEndpoint: import.meta.env.REACT_APP_ENTITYSTORE_API,
  excelEngineApiEndpoint: import.meta.env.REACT_APP_EXCELENGINE_API,
  utilitiesApiEndpoint: import.meta.env.REACT_APP_APIKEY_API,
  showNavigation: import.meta.env.REACT_APP_NAVIGATION,
  showUserManagement: import.meta.env.REACT_APP_USERS_MANAGEMENT,
  showApikeyManagement: import.meta.env.REACT_APP_API_KEY_MANAGEMENT,
  userManagementEndpoint: import.meta.env.REACT_APP_API,
};

export const setConfig = async (
  config: GlobalConfiguration,
): Promise<boolean> => {
  globalConfig = config;
  return true;
};

export const getConfig = () => {
  return globalConfig;
};

export const configUrl = () => {
  return `${window.location.protocol}//${window.location.host}/config.json`;
};

const isValidConfigProperty = (
  propertyName: string | boolean | number | undefined,
): boolean => {
  if (typeof propertyName === 'boolean') {
    return true;
  }

  if (typeof propertyName === 'number') {
    return true;
  }

  if (typeof propertyName === 'string' && propertyName.trim().length > 0) {
    return true;
  } else if (
    typeof propertyName === 'string' &&
    propertyName.trim().length === 0
  ) {
    return false;
  }

  if (propertyName === undefined || propertyName === null) {
    return false;
  }

  return false;
};
export const getPreferredConfig = async (
  globalConfigState: GlobalConfiguration,
): Promise<GlobalConfiguration> => {
  const data = {
    keycloakClientName: !isValidConfigProperty(
      globalConfigState.keycloakClientName,
    )
      ? import.meta.env.REACT_APP_CLIENT_ID
      : globalConfigState.keycloakClientName,
    defaultTenant: !isValidConfigProperty(globalConfigState.defaultTenant)
      ? import.meta.env.REACT_APP_REALM
      : globalConfigState.defaultTenant,
    keycloakApiEndpoint: !isValidConfigProperty(
      globalConfigState.keycloakApiEndpoint,
    )
      ? import.meta.env.REACT_APP_KEYCLOAK_API
      : globalConfigState.keycloakApiEndpoint,
    entitystoreApiEndpoint: !isValidConfigProperty(
      globalConfigState.entitystoreApiEndpoint,
    )
      ? import.meta.env.REACT_APP_ENTITYSTORE_API
      : globalConfigState.entitystoreApiEndpoint,
    utilitiesApiEndpoint: !isValidConfigProperty(
      globalConfigState.utilitiesApiEndpoint,
    )
      ? import.meta.env.REACT_APP_APIKEY_API
      : globalConfigState.utilitiesApiEndpoint,
    showNavigation: !isValidConfigProperty(globalConfigState.showNavigation)
      ? import.meta.env.REACT_APP_NAVIGATION
      : globalConfigState.showNavigation,
    showUserManagement: !isValidConfigProperty(
      globalConfigState.showUserManagement,
    )
      ? import.meta.env.REACT_APP_USERS_MANAGEMENT
      : globalConfigState.showUserManagement,
    showApikeyManagement: !isValidConfigProperty(
      globalConfigState.showApikeyManagement,
    )
      ? import.meta.env.REACT_APP_API_KEY_MANAGEMENT
      : globalConfigState.showApikeyManagement,
    userManagementEndpoint: !isValidConfigProperty(
      globalConfigState.userManagementEndpoint,
    )
      ? import.meta.env.REACT_APP_API
      : globalConfigState.userManagementEndpoint,
    excelEngineApiEndpoint: !isValidConfigProperty(
      globalConfigState.excelEngineApiEndpoint,
    )
      ? import.meta.env.REACT_APP_EXCELENGINE_API
      : globalConfigState.excelEngineApiEndpoint,
  };
  return data;
};
